const FALLBACK_ZONES = [
  'UTC',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Paris',
  'Europe/Belgrade',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Sao_Paulo',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
]

let cache: string[] | null = null

export function getTimeZones(): string[] {
  if (cache) return cache
  let zones: string[] = []
  try {
    const intl = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }
    zones = intl.supportedValuesOf?.('timeZone') ?? []
  } catch {
    zones = []
  }
  if (zones.length === 0) zones = FALLBACK_ZONES
  if (!zones.includes('UTC')) zones = ['UTC', ...zones]
  cache = zones
  return cache
}

export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

/** e.g. `GMT+2` for a zone at the current instant. */
export function timeZoneOffsetLabel(zone: string, at: Date = new Date()): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'shortOffset' }).formatToParts(at)
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? ''
  } catch {
    return ''
  }
}

export function timeZoneLabel(zone: string): string {
  return zone.replace(/_/g, ' ')
}
